import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class ReportArtifactApi extends BaseApi {
    constructor(client) { super(client, '/report-artifacts'); }
    async create(data) { try { return (await this.client.post(this.basePath, data)).data; } catch (error) { throw ApiError.fromResponse(error); } }
    async list() { try { return (await this.client.get(this.basePath)).data; } catch (error) { throw ApiError.fromResponse(error); } }
    async get(reportId) { try { return (await this.client.get(`${this.basePath}/${encodeURIComponent(reportId)}`)).data; } catch (error) { throw ApiError.fromResponse(error); } }
    async getViewerAccess(reportId) {
        try { return (await this.client.get(`${this.basePath}/${encodeURIComponent(reportId)}/viewer-access`)).data; }
        catch (error) { throw ApiError.fromResponse(error); }
    }
    async updateLifecycle(reportId, data) {
        try { return (await this.client.patch(`${this.basePath}/${encodeURIComponent(reportId)}/lifecycle`, data)).data; }
        catch (error) { throw ApiError.fromResponse(error); }
    }
    async download(reportId, format = 'repx') {
        try { return await this.client.get(`${this.basePath}/${encodeURIComponent(reportId)}/download`, { params: { format }, responseType: 'blob' }); }
        catch (error) { throw ApiError.fromResponse(error); }
    }
}
